import { render, staticRenderFns } from "./legacy.vue?vue&type=template&id=46f6fecc&scoped=true&"
import script from "./legacy.vue?vue&type=script&lang=js&"
export * from "./legacy.vue?vue&type=script&lang=js&"
import style0 from "./legacy.vue?vue&type=style&index=0&id=46f6fecc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f6fecc",
  null
  
)

export default component.exports